import { AuthContext } from '@repo-level/core-front';
import { setCookie } from 'helpers/common';
import { useContext, useEffect } from 'react';

const COOKIE_EXPIRES = 365 * 10; // 10 years

enum COOKIE_NAME {
  IS_REGISTERED = 'is_registered',
  ACTIVE_SESSION = 'active_session',
}

export const useAuthCookies = () => {
  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (isAuthenticated) {
      setCookie(COOKIE_NAME.IS_REGISTERED, 'true', COOKIE_EXPIRES);
      setCookie(COOKIE_NAME.ACTIVE_SESSION, 'true', COOKIE_EXPIRES);
    } else {
      setCookie(COOKIE_NAME.ACTIVE_SESSION, 'false', COOKIE_EXPIRES);
    }
  }, [isAuthenticated]);
};
